import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = {
  class: "modal-content",
  style: {"height":"calc(100vh - 50px)"}
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = {
  style: {"max-height":"calc(100vh - 280px)","overflow-y":"auto"},
  class: "mt-3"
}
const _hoisted_10 = { class: "mt-3 mb-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { style: {"max-height":"calc(100vh - 280px)","overflow-y":"auto"} }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["onClick"]

import { ref, computed, onMounted } from 'vue'
    import { ellipsis, isNullOrWhitespace, strCompareLowerCase } from '@common/Common'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AttributesSelector',
  props: {
    CorrelationId: {},
    Attributes: {},
    SelectedAttributesIds: {}
  },
  emits: ["save", "close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- local state ----------------

    const attributes = ref<AttributeViewModel[]>([])
    const sections = ref<SectionViewModel[]>([])
    const searchPhrase = ref('') // ✅ NEVER nullable

    // ---------------- computed ----------------

    const sectionsView = computed(() =>
    {
        if (isNullOrWhitespace(searchPhrase.value))
        {
            return sections.value
        }

        return sections.value.filter(s => s.attributesView.length > 0)
    })

    const selectedAttributes = computed(() =>
        attributes.value.filter(a => a.IsSelected)
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        attributes.value = props.Attributes.map(a => new AttributeViewModel(a))

        attributes.value
            .filter(a => props.SelectedAttributesIds.includes(a.AttributeId))
            .forEach(a => a.IsSelected = true)

        const sectionNames = attributes.value
            .map(a => a.Section)
            .filter((v, i, arr) => arr.indexOf(v) === i)
            .sort(strCompareLowerCase)

        sections.value = sectionNames.map(
            name => new SectionViewModel(
                name,
                attributes.value.filter(a => a.Section === name),
                searchPhrase
            )
        )
    })

    // ---------------- actions ----------------

    function save()
    {
        emit('save', {
            CorrelationId: props.CorrelationId,
            SelectedAttributesIds: selectedAttributes.value.map(a => a.AttributeId)
        })
    }

    function close()
    {
        emit('close')
    }

    // ---------------- local VMs ----------------

    class SectionViewModel
    {
        constructor(
            public Name: string,
            private Attributes: AttributeViewModel[],
            private searchPhrase: { value: string }
        ) { }

        get attributesView(): AttributeViewModel[]
        {
            const phrase = this.searchPhrase.value

            if (isNullOrWhitespace(phrase))
            {
                return this.Attributes
            }

            const lower = phrase.toLowerCase()
            return this.Attributes.filter(a =>
                `${a.Name} ${a.Section}`.toLowerCase().includes(lower)
            )
        }
    }

    class AttributeViewModel
    {
        AttributeId: number
        Name: string
        Section: string
        NameEllipsis: string
        IsSelected = false

        constructor(attr: { AttributeId: number; Name: string; Section: string })
        {
            this.AttributeId = attr.AttributeId
            this.Name = attr.Name
            this.Section = attr.Section
            this.NameEllipsis = ellipsis(this.Name, 52)
        }

        toggleSelect()
        {
            this.IsSelected = !this.IsSelected
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Select attributes", -1 /* CACHED */)),
            _createElementVNode("button", {
              onClick: close,
              type: "button",
              class: "close"
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "search",
                    placeholder: "Search...",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      searchPhrase.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "input-group-append" }, [
                    _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", {
                        class: "fa-solid fa-magnifying-glass",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectionsView.value, (s) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: s.Name
                    }, [
                      _createElementVNode("h6", _hoisted_10, _toDisplayString(s.Name), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.attributesView, (attr) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: attr.AttributeId
                        }, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (attr.toggleSelect())
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-regular fa-lg mr-1", { 'fa-square-check': attr.IsSelected, 'fa-square': !attr.IsSelected}])
                            }, null, 2 /* CLASS */),
                            _createElementVNode("span", {
                              title: attr.Name
                            }, _toDisplayString(attr.NameEllipsis), 9 /* TEXT, PROPS */, _hoisted_12)
                          ], 8 /* PROPS */, _hoisted_11)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h5", null, "Selected attributes (" + _toDisplayString(selectedAttributes.value.length) + "):", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAttributes.value, (attr) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: attr.AttributeId,
                      class: "p-2 bg-secondary m-2 text-white"
                    }, [
                      _createElementVNode("span", {
                        title: attr.Name
                      }, _toDisplayString(attr.NameEllipsis), 9 /* TEXT, PROPS */, _hoisted_15),
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-0 border-0 text-white",
                        style: {"background-color":"transparent","font-size":"1.3rem","float":"right"},
                        onClick: ($event: any) => (attr.toggleSelect())
                      }, " × ", 8 /* PROPS */, _hoisted_16)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              onClick: save,
              type: "button",
              class: "btn btn-primary"
            }, "Save & Close"),
            _createElementVNode("button", {
              onClick: close,
              type: "button",
              class: "btn btn-outline-secondary"
            }, "Cancel")
          ])
        ])
      ])
    ])
  ]))
}
}

})